// extracted by mini-css-extract-plugin
export var sponsors = "Sponsors-module--sponsors--7faME";
export var sponsorEntry = "Sponsors-module--sponsorEntry--iz1vM";
export var sponsorEntry__logo = "Sponsors-module--sponsorEntry__logo--BV+VB";
export var sponsorEntry_box = "Sponsors-module--sponsorEntry_box--rFeEv";